import type { ExternalTableSchema } from '@packages/table-builder';

// useGetTransferAllocateDashboard — dashboard grouped list

export const transfersAllocateShareDashboardBaseSchema: ExternalTableSchema = {
  metadata: {
    title: 'Transfer and Allocate Dashboard',
    entity: 'TransfersAllocateShareDashboard',
    description: 'Transfer and allocate dashboard grouped by date.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/transfer-allocate-dashboard',
    method: 'GET',
    rowIdField: 'id',
    requestParams: {
      Filter: '',
      CompanyId: 'filters.companyId',
      ContainerStatusIds: 'filters.containerStatusIds',
    },
    filters: [
      {
        name: 'companyId',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'containerStatusIds',
        placeholder: 'Container Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/transfer-allocate/container-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'creationTime',
      header: 'Date',
      type: 'date',
      sortable: true,
      width: 140,
      align: 'center',
      emptyDisplay: '-',
    },
    {
      field: 'companyName',
      header: 'Company',
      sortable: false,
      width: 120,
    },
    {
      field: 'ticker',
      header: 'Ticker',
      sortable: true,
      width: 150,
      align: 'center',
    },
    {
      field: 'containerStatus',
      header: 'Container Status',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: {
          Executed: 'success',
          Placed: 'success',
          Allocated: 'info',
          Pending: 'info',
          Cancelled: 'error',
          'Partially Filled': 'pink-tag',
          Received: 'success',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'dwacNumber',
      header: 'Dwac Number',
      sortable: true,
      width: 200,
      align: 'center',
    },
    {
      field: 'totalTransferShare',
      header: 'Total Transfer Shares',
      sortable: true,
      width: 150,
      align: 'center',
      aggregate: { fn: 'sum' },
    },
  ],

  actions: {
    row: [{ id: 'VIEW_DETAILS_TRANSFERS_ALLOCATE_DASHBOARD', label: 'View Details' }],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'none' },
    virtualScroll: { enabled: false },
    groupBy: {
      fields: ['creationTime'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
      groupHeader: { showCount: true },
    },
  },
};
